export default __webpack_public_path__ + "static/media/background.bd636201.jpg";